import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import ThumbUpIcon from '../../../../assets/notification-thumbup-icon.svg';
import ThumbDownIcon from '../../../../assets/notification-thumbdown-icon.svg';

const UpdateResponseNotification = ({ notification }) => {
  const meta = getMeta(notification);
  const isApproved = meta.responseType === 'APPROVED';
  const subIcon = isApproved ? ThumbUpIcon : ThumbDownIcon;

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={subIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> {isApproved ? 'approved' : 'rejected'} </span>
          <span className="font-bold text-growth-green">your response.</span>
        </p>

        {meta.responseTitle && (
          <p className="text-sm font-bold text-growth-green-900 mt-1">
            &ldquo;{meta.responseTitle}&rdquo;
          </p>
        )}

        {meta.requestTitle && (
          <p className="text-sm text-gray-600 mt-1">to &ldquo;{meta.requestTitle}&rdquo;</p>
        )}
      </div>
    </div>
  );
};

export default UpdateResponseNotification;
